export default __webpack_public_path__ + "static/media/gallery-21.457d39cb.jpg";